import React from "react";
import { Outlet } from "react-router-dom";
import vistaflowPicto from "../../../vistaflow-picto.png";

export default function PublicLayout() {
  return (
    <>
      <div className="text-center p-10">
        <img src={vistaflowPicto} alt="Vistaflow logo" className="block m-auto w-20" />
        <h1 className="text-vistadark text-5xl pl-3 font-['Nunito_Sans'] font-bold">
          VistaFlow
        </h1>
      </div>
      <Outlet />
    </>
  );
}
